import { get } from '../services/Generic.api';

const DASHBOARD_MEDIA_BASE = (process.env.REACT_APP_DASHBOARD_URL || "").replace(/\/+$/, "");
const S3_MEDIA_BASE = (
  process.env.REACT_APP_S3_URL || process.env.REACT_APP_S3_URL_BASE
).replace(/\/+$/, "");

const formatDateBR = (date) => {
  if (!date) return null;

  if (typeof date === "string" && date.includes("-")) {
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`;
  }

  return null;
};

const normalizeThumbnailUrl = (url) => {
  if (typeof url !== "string" || !url) return url;
  if (!DASHBOARD_MEDIA_BASE) return url;
  if (!S3_MEDIA_BASE) return url;
  return url.replace(S3_MEDIA_BASE, DASHBOARD_MEDIA_BASE);
};

export const fetchMediaHighlightsStreamlit = async (clientId, dateStart, dateEnd) => {
  const params = {
    client: clientId,
    date_start: formatDateBR(dateStart),
    date_end: formatDateBR(dateEnd),
  };

  const response = await get('/dashboard/highlights-news-analysis/', params);

  if (!Array.isArray(response)) return response;

  return response.map((item) => ({
    ...item,
    thumbnails: Array.isArray(item?.thumbnails)
      ? item.thumbnails.map(normalizeThumbnailUrl)
      : item?.thumbnails,
  }));
};
